






















import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import DatePeriodSelect from "./DatePeriodSelect.vue";

export default Vue.extend({
  name: "SettingsCategoryTypeDetails",
  components: {
    OverlayWindow,
    Loading,
    DatePeriodSelect,
  },
  props: {},
  data() {
    return {
      data: {
        beginDate: null,
        endDate: null,
      } as {
        beginDate: string | null;
        endDate: string | null;
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {},
  },
  watch: {},
  computed: {},
});
